(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Prepare",
                {
                    url: "/Prepare",
                    component: "prepare",
                    PageTitle: "Prepare",
                    requiredPermissions: "Prepare:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("prepare",
        {
            templateUrl: "App/Resources/Prepare/prepare.html",
            controller: prepareCtrl,
            bindings: {
                states: "<"
            }
        });

    prepareCtrl.$inject = ["amplitudeService", "$cookies"];

    function prepareCtrl(amplitudeService, $cookies) {
        var $ctrl = this;
        window.p = this;
        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.openExternalInterestForm = function () {

            var date = new Date();
            var dateString = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();

            $cookies.put('prepare_interest_form_clicked', dateString);
            $ctrl.submittedDate = dateString;
            window.open("https://im448.infusionsoft.com/app/form/instructor-application");
        };

        $ctrl.submittedDate = $cookies.get('prepare_interest_form_clicked');

    }
})(window.app, window.angular); // jshint ignore:line